import React from "react";

interface GenericButtonProps {
  type?: "button" | "submit" | "reset";
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  isFull?: boolean;
  children: React.ReactNode;
}

export const GenericButton: React.FC<GenericButtonProps> = ({
  type = "submit",
  onClick,
  disabled = false,
  className,
  children,
  isFull = true,
}) => {
  const defaultClass = `${
    isFull ? "w-full" : ""
  } block bg-blue-800 text-white font-semibold rounded-lg px-4 ${
    className?.includes("py-") ? "" : "py-3"
  }`;
  const activeClass = "bg-blue-800";
  const hoverClass = className ?? "hover:bg-blue-900 focus:bg-blue-900";

  const combinedClass = `${defaultClass} ${activeClass} ${hoverClass} ${
    className || ""
  }`;

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={combinedClass}
    >
      {children}
    </button>
  );
};
